import React__default from 'react';
import PropTypes from 'prop-types';
import { brands } from '../../tools/constants.js';

var propTypes = {
  /** Unique identifier for the textarea and its label */
  id: PropTypes.string.isRequired,
  /** Visible and accessible label for the textarea */
  label: PropTypes.string.isRequired,
  /** Callback fired when the textarea value changes. Receives the event object */
  onChange: PropTypes.func.isRequired,
  /** ID of an element describing the textarea (e.g., error or help text). Used for accessibility */
  ariaDescribedBy: PropTypes.string,
  /**
   *  autocomplete attribute identifies the type of data needed
   *  from the user so that the field can be accurately autofilled.
   *  Add it to prevent accessibility issues.
   */
  autoComplete: PropTypes.string,
  /** Brand identifier for styling */
  brand: PropTypes.oneOf(brands),
  /** Optional content rendered below the textarea (e.g., error message, character count) */
  children: PropTypes.node,
  /** If true, marks the textarea as invalid and sets `aria-invalid` */
  isInvalid: PropTypes.bool,
  /** If true, marks the textarea as required and sets `aria-required` and `required` */
  isRequired: PropTypes.bool,
  /** Maximum number of characters allowed */
  maxLength: PropTypes.number,
  /** Current value of the textarea */
  value: PropTypes.string
};
function Textarea(_ref) {
  var ariaDescribedBy = _ref.ariaDescribedBy,
    autoComplete = _ref.autoComplete,
    brand = _ref.brand,
    children = _ref.children,
    id = _ref.id,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    label = _ref.label,
    maxLength = _ref.maxLength,
    onChange = _ref.onChange,
    value = _ref.value;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "textarea",
    "data-brand": brand,
    "data-testid": "textarea"
  }, /*#__PURE__*/React__default.createElement("textarea", {
    autoComplete: autoComplete,
    "aria-describedby": ariaDescribedBy,
    "aria-invalid": isInvalid,
    "aria-required": isRequired,
    "data-filled": !!value,
    id: id,
    maxLength: maxLength,
    onChange: onChange,
    required: isRequired,
    value: value
  }), /*#__PURE__*/React__default.createElement("label", {
    className: "float-label",
    htmlFor: id
  }, label), /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true",
    className: "placeholder",
    "data-testid": "placeholder"
  }, label), children);
}
Textarea.propTypes = propTypes;

export { Textarea as default };
//# sourceMappingURL=Textarea.js.map
